export default {
  en: {
    dropFile: 'Drop a file or click to select a file to upload.',
    selectButton: 'Upload & accept',
    title: 'License Upload',
    eula: 'End User License Agreement',
    acceptance: 'By uploading the license I accept the',
  },
};
